import { render, staticRenderFns } from "./SectionSelect.vue?vue&type=template&id=0abfbaf3&scoped=true"
import script from "./SectionSelect.vue?vue&type=script&lang=js"
export * from "./SectionSelect.vue?vue&type=script&lang=js"
import style0 from "./SectionSelect.vue?vue&type=style&index=0&id=0abfbaf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abfbaf3",
  null
  
)

export default component.exports